
export const popupEqualsTrueHandler = async ({ params }) => {
	if (params && canPopup(params)) {
		let { locid: locationId, pt: postCodeType, alid, locact } = params;

		locationId = isNaN(Number(locationId)) ? -1 : Number(locationId);
		postCodeType ??= -1;

		let {
			getPayloadForPopupTrue,
			launchBarkModal,
			nrfAutoStartHandled,
			markNrfAutoStartHandled,
		} = await import('@bark/bark-core');

		// The eager nrfp handler (bark-core entry service) may have already
		// started the flow before core boot finished
		if (nrfAutoStartHandled()) {
			return;
		}
		// ...and conversely, tell it to stand down when this handler wins
		markNrfAutoStartHandled();

		// A bark_mode in the url overrides the page's attribution
		if (params.bark_mode) {
			$('#bark_mode').val(params.bark_mode);
		}

		// prefilled_loc=true means the location is a suggestion for the
		// location step, not an answer (BBQ-7137) — prefilling is the eager
		// handler's job, so as its fallback just don't skip the step
		if (params.prefilled_loc === 'true') {
			locationId = -1;
			postCodeType = -1;
		}

		const thePayloadFormdata = getPayloadForPopupTrue({
			locationId,
			postCodeType,
			alid,
			locact,
		});

		launchBarkModal(thePayloadFormdata);

	}
};

function canPopup(params) {
	const formCanPopup = $('#project-create-form').attr('can-popup') !== undefined;
	const isPopupTurnedOffOnPage = $('.bark-journey-popup-off').length > 0;

	if (params) {
		if (params.autosearch) {
			return true;
		}
		if ((params.popup === 'true' || params.nrfp === 'true') && formCanPopup && !isPopupTurnedOffOnPage) {
			return true;
		}
	}
	return false;
}
